/**
 * 业务订单导入
 */
import { ORDERIMPORT } from '../types';

export default {
    name: `${ORDERIMPORT}`,
    path: '/orderImport',
    component: () => import(/* webpackChunkName: 'orderImport' */ '@/views/orderImport/'),
    redirect: { name: `${ORDERIMPORT}Index` },
    meta: {
        title: '业务订单导入',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${ORDERIMPORT}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'orderImport' */ '@/views/orderImport/home/Home.vue'),
        },
    ],
};
